const ReactionsList = [
    { icon: "👍" },
    { icon: "❤️" },
    { icon: "😂" },
    { icon: "😮" },
    { icon: "😢" },
    { icon: "🚀" },
    { icon: "🙏🏻" },
]

export default ReactionsList